@if (skogsvardtradslag.length > 0) {
  <div class="row mt-4 ms-0">
    <div class="col-11 min-width padding-right">
      <rask-list [data]="skogsvardtradslag">
        <rask-list-column header="trädslag" field="tradslag" [nowrap]="true" [sortable]="false" [width]="'80px'">
          <ng-template let-row="row">
            {{row.tradslag}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="planttyp" field="planttyp" [nowrap]="true" [sortable]="false" [width]="'118px'">
          <ng-template let-row="row">
            {{row.planttyp}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="skydd" field="skydd" [nowrap]="true" [sortable]="false" [width]="'82px'">
          <ng-template let-row="row">
            {{row.skydd}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="plantantal" field="plantantal" [sortable]="false" [width]="'80px'">
          <ng-template let-row="row">
            {{row.plantantal}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="arealsandel" field="arealsandel" [sortable]="false" [width]="'85px'">
          <ng-template let-row="row">
            {{row.arealsandel}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="mål PL/ha" field="malplantorHa" [sortable]="false" [width]="'70px'">
          <ng-template let-row="row">
            {{row.malplantorHa}}
          </ng-template>
        </rask-list-column>
      </rask-list>
    </div>
  </div>
}
